import { getToken } from "../storage/authStorage";
import { API_BASE_URL } from "../../../config/api";

class APIError extends Error {
  public status: number;
  public data: any;

  constructor(message: string, status: number, data: any = null) {
    super(message);
    this.name = "APIError";
    this.status = status;
    this.data = data;
  }
}

const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};

// Get current user's permissions
export const getMyPermissions = async (): Promise<any> => {
  const token = getToken();
  if (!token) {
    throw new APIError(
      "No authentication token found",
      HTTP_STATUS.UNAUTHORIZED
    );
  }

  const url = `${API_BASE_URL}/api/permissions/me`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new APIError(
        errorData.message || `HTTP error! status: ${response.status}`,
        response.status,
        errorData
      );
    }

    return await response.json();
  } catch (error) {
    if (error instanceof APIError) {
      throw error;
    }
    throw new APIError(
      `Network error: ${
        error instanceof Error ? error.message : "Unknown error"
      }`,
      HTTP_STATUS.INTERNAL_SERVER_ERROR
    );
  }
};
